export function SecondaryButton({
  children,
  onClick,
  linkUrl = '',
  disabled = false,
}: {
  children: React.ReactNode
  onClick?: () => void
  linkUrl?: string
  disabled?: boolean
}) {
  if (linkUrl) {
    return (
      <a
        className="border-2 bg-white flex text-base items-center gap-2 justify-center hover:bg-old-primary hover:text-white border-old-primary text-old-primary px-4 py-2 rounded-lg"
        href={`https://${linkUrl}`}
        target="_blank"
      >
        {children}
      </a>
    )
  }
  return (
    <button
      type="button"
      className={`border-2 border-none text-base text-secondaryBlue flex items-center gap-2 justify-center px-4 py-2 rounded-sm ${
        disabled ? 'bg-blueLight cursor-default' : 'bg-blue  text-secondaryBlue hover:bg-blueLight'
      }`}
      onClick={() => {
        if (!disabled) onClick()
      }}
    >
      {children}
    </button>
  )
}
